import React from "react";

function SvgIcMapPoi076(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.5 20a1.5 1.5 0 110-3 1.5 1.5 0 010 3m9-10c.828 0 1.749.624 2.057 1.393l.959 2.396-.036.055-1.704-1.708-.148-.371c-.098-.246-.349-.484-.627-.627A1.127 1.127 0 0016.5 11h-7c-.159 0-.335.052-.502.138-.277.143-.528.381-.627.627l-.719 1.796-.482 1.207c-.052.128.018.232.157.232h5.191c.143.431.382.836.723 1.178l4.642 4.653a3.048 3.048 0 002.496.87 2.96 2.96 0 00.621-.14V22a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H9v1a1 1 0 01-1 1H6a1 1 0 01-1-1v-5c0-.552.224-1.224.5-1.5L6 15l1.442-3.607C7.75 10.624 8.671 10 9.5 10zm10.281-2.12c.483.3.631.939.328 1.422l-6.203 9.935a1.033 1.033 0 01-1.607.182l-4.64-4.653a1.033 1.033 0 111.462-1.458l3.723 3.73 5.513-8.83c.303-.483.94-.631 1.424-.328z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi076;
